// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","menuContainer":"_22yP6","menuDescription":"_1ajgQ","label":"_1EnRn","picture":"yE1m6","submenu":"_31729","firstSubmenu":"jNed2"};